export default {
    cities: [],
    countries: [],
    currencies: [],
    cancelReasons: [],
}
